<template>
  <o-view :has-white-background="true">
    <o-nav-bar title="Citroën Berlingo Cargo" :has-back-button="true" />
    <o-section>
      <img
        src="/images/cambio-car.png"
        alt="Citroën Berlingo Cargo"
        class="c-car-preview"
      />
    </o-section>
    <o-section>
      <o-key-value label="Zitplaatsen" value="2" />
      <o-key-value label="Laadruimte">
        <template #value>
          Volume laadruimte = 2,5m³<br />
          Lengte laadruimte: 109 cm<br />
          Breedte laadruimte: 123 cm<br />
          Breedte tussen de wielkassen: 117 cm<br />
          Hoogte laadruimte: 114 cm
        </template>
      </o-key-value>
      <o-key-value label="Afmetingen">
        <template #value>
          L: 4380 mm (minimum)<br />B: 2112 mm<br />H: 1803 mm
        </template>
      </o-key-value>
      <o-key-value label="Gewicht">
        <template #value>
          Leeg gewicht 1485 kg<br />Laadgewicht 600 kg
        </template>
      </o-key-value>
      <o-key-value
        label="Uitrusting"
        value="5-deurs, Parkeerhulp, Airco, Manuele versnellingsbak, Radio/USB, Reservewiel"
      />
      <o-key-value label="Uitstoot" value="135g CO²" />
      <o-key-value label="Brandstof" value="Diesel" />
      <o-key-value label="Kleur" value="Grijs" />
      <o-key-value
        label="Wagenklasse voor reservatie"
        value="M Mini Van Cargo - 2 plaatsen"
      />
    </o-section>
  </o-view>
</template>

<script>
import OKeyValue from '@/components/base/OKeyValue.vue'
export default {
  name: 'CambioCarInfo',
  components: { OKeyValue }
}
</script>

<style lang="scss">
.c-section img.c-car-preview {
  margin: 0 auto;
  max-width: 30rem;
}
</style>
